// ---Dependencies
import React from "react";
// ---Layout
import { Spinner } from "../tap/components/Spinner";
import TAPRouter from "../tap/router";

/**
 * AuthorizedApp Component: Is the main app, providers and Hocs Can be added here
 * @returns {ReactElement}
 */
export const AuthorizedApp = () => (
  <>
    <Spinner />
    {/* Global Scope components can be added here */}
    <TAPRouter />
  </>
);
